<template>
  <div class="modal_wrapper">
    <div
      id="keywords_modal"
      class="modal_window white_box keywords_modal"
    >
      <div class="video_wrapper">
        <div class="heading_wrapper">
          <h3 class="heading">
            Top 10 Across All Keywords
          </h3>
          <button
            class="close_modal close_btn"
            @click="closeModal()"
          >
            <svg
              fill="none"
              height="32"
              viewBox="0 0 32 32"
              width="32"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M25 7L7 25"
                stroke="#040707"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
              />
              <path
                d="M25 25L7 7"
                stroke="#040707"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
              />
            </svg>
          </button>
        </div>

        <div
          v-for="(competitor, index) in competitors"
          :key="index"
          :class="'section_wrap '+(settings === index ? 'open' : '')"
        >
          <div
            class="section_head"
            @click="(settings === index ? settings = '' : settings = index)"
          >
            <a
              v-if="canEditCompetitors"
              :href="`/competition?website=${encodeURIComponent(competitor.website)}`"
              class="tooltipster text-warning"
              target="_blank"
              title="Add website to your competitors"
            >
              <h3 class="section_heading">
                {{ competitor.domain }}
              </h3>
            </a>
            <div class="section_head">
              {{ competitor.count }} keywords
              <i class="icon arrow_down_icon caret" />
            </div>
          </div>
          <accordion-transition>
            <div
              v-if="settings === index"
              class="section_body"
            >
              <div class="white_box">
                <table class="keywords_table">
                  <thead>
                    <tr>
                      <td>
                        <span>Keyword</span>
                      </td>
                      <td width="20%">
                        <span>Position</span>
                      </td>
                      <td>
                        <span>URL</span>
                      </td>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(serp, serpIndex) in sortSerps(competitor.serps)"
                      :key="serpIndex"
                    >
                      <td>
                        {{ serp.keyword }}
                      </td>
                      <td>
                        {{ serp.position }}
                      </td>
                      <td>
                        <a
                          :href="serp.page"
                          :title="urlPathname(serp.page)"
                          class="table_link tooltipster"
                          target="_blank"
                        >{{ urlPathname(serp.page) }}</a>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </accordion-transition>
        </div>

        <div
          v-if="loading"
          class="loading_placeholder"
        >
          <i class="fa fa-btn fa-spinner fa-spin" /> Loading Data
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AccordionTransition from '../../../../reports/components/global/transitions/AccordionTransition.vue';
import {mapGetters} from "vuex";
import axios from 'axios';

export default {
  components: {
    AccordionTransition,
  },
  data() {
    return {
      loading: true,
      settings: '',
      error: '',
      competitors: []
    }
  },
  computed: {
    ...mapGetters('user', [
      'canEditCompetitors',
    ]),
  },
  mounted() {
    this.getCompetitonData();
  },
  methods: {
    getCompetitonData() {
      axios.get('/ajax/keywords/top-competitors').then(response => {
        this.competitors = response.data;
        this.loading = false;
      }).catch(() => {
        this.error = true;
        this.loading = false;
      });
    },
    urlPathname(url) {
      if (!url) return '';
      const parsedUrl = new URL(url);
      return parsedUrl.pathname;
    },
    sortSerps(serps) {
      return serps.sort((a, b) => {
        return a.position - b.position;
      });
    },
    closeModal() {
      this.$parent.showCompetitionModal = false;
    }
  },
}
</script>

<style scoped src="../../../../reports/css/modal.css" />

<style scoped>
.modal_wrapper {
  z-index: 100;
  position: fixed;
  display: flex;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  -webkit-transition: .3s;
  -o-transition: .3s;
  transition: .3s;
  padding: 2vh 0;
  overflow: auto;
  background-color: rgba(0, 0, 0, 0.2);
}

.modal_wrapper::-webkit-scrollbar {
  width: 0;
}

.modal_window {
  position: relative;
  margin: auto;
  width: 1000px;
  z-index: 100;
  -webkit-box-shadow: 0px 10px 30px rgba(4, 7, 7, 0.2);
  box-shadow: 0px 10px 30px rgba(4, 7, 7, 0.2);
  border-radius: .75rem;
}

.close_btn {
  height: auto;
}

.heading_wrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}

.heading {
  font-weight: 700;
  line-height: 1.42;
  letter-spacing: -0.042em;
  color: #040707;
  font-size: 1.5rem;
}

.video_wrapper .btn {
  height: 42px;
  padding-top: 0;
  padding-bottom: 0;
  margin: 0;
}

.loading_placeholder {
  width: 100%;
  height: 315px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
}

.loading_placeholder i {
  margin-right: 5px;
}

.section_heading {
  font-weight: 400;
}

.keywords_table {
  width: 100%;
  border-spacing: 0;
  border-collapse: collapse;
  table-layout: fixed;
}

.keywords_table thead tr td {
  padding: 0rem .75rem .75rem;
}

.keywords_table thead tr td:nth-of-type(2),
.keywords_table tbody tr td:nth-of-type(2) {
  text-align: center;
}

.keywords_table tr td:nth-of-type(3) {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow-x: hidden;
}

.keywords_table tbody tr td {
  padding: .75rem;
}

.keywords_table thead td span {
  font-weight: 500;
  font-size: 16px;
  line-height: 26px;
  letter-spacing: -0.25px;
  margin-right: 0.25rem;
}

.keywords_table tbody tr:nth-of-type(2n+1) {
  background: var(--table-secondary-color);
}

.table_link {
  color: var(--primary-color);
}

.loading_placeholder {
  width: 100%;
  height: 315px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
}

.loading_placeholder i {
  margin-right: 5px;
}
</style>
